import React, {PureComponent} from "react"
import {Input} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import {FormatMessage} from "@irati/utils/lang/types"

function schema(formatMessage: FormatMessage) {
  return Validation.string(formatMessage({id: "platform.mfa.mfaCode.errors.isRequired"}))
}

interface Props extends InjectIntl {
  onChange(value: string): void
  value?: string
  label: string
}

class MFACode extends PureComponent<Props> {
  render() {
    return (
      <Input
        name="mfaCode"
        label={this.props.label}
        placeholder="Code"
        autoFocus
        validation={schema(this.props.formatMessage)}
        {...this.props}
      />
    )
  }
}

export default injectIntl(MFACode)
